import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ScrollSpy from "react-ui-scrollspy";
import GotoTop from "../common/GotoTop";
import ContactCTA from "../contact/contactCTA";
import Banner from "./Banner";
import Benefits from "./Benefits";
import Db_faq from "./Db_faq";
import Info from "./Info";
import Services from "./Services";

const DatabaseMigrationHome = () => {
  return (
    <div>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Flint Infotech - Database Migration & IT Consulting Services
          </title>
          <meta
            name="description"
            content="Flint Infotech offers database migration, IT consulting, cloud management, web development, and AI Solutions services. Contact us for innovative solutions and digital transformation."
          />
          <link rel="canonical" href="https://flintinfotech.com/" />

          <meta
            property="og:title"
            content="Flint Infotech - Database Migration & IT Consulting Services"
          />
          <meta
            property="og:description"
            content="Flint Infotech offers database migration, IT consulting, cloud management, web development, and AI Solutions services. Contact us for innovative solutions and digital transformation."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://flintinfotech.com/" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Flint Infotech - Database Migration & IT Consulting Services"
          />
          <meta
            name="twitter:description"
            content="Flint Infotech offers database migration, IT consulting, cloud management, web development, and AI Solutions services. Contact us for innovative solutions and digital transformation."
          />

          <meta name="robots" content="index, follow" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
      </HelmetProvider>

      <Banner />
      <ScrollSpy>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <Info />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <Services />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <Benefits />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <Db_faq />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <ContactCTA />
        </AnimationOnScroll>
      </ScrollSpy>
      <GotoTop />
    </div>
  );
};

export default DatabaseMigrationHome;
